import { Box, Flex } from '@mantine/core'

import type { DonutChartCellData } from '@/components/@Shared/DonutChart/DonutChart.types'
import type { DonutChartTooltipProps } from '@/components/@Shared/DonutChart/partials/DonutChartTooltip/DonutChartTooltip.types'
import { Text } from '@/components/Text/Text'

import classes from './DonutChartTooltip.module.css'

export function DonutChartTooltip({ payload }: DonutChartTooltipProps) {
  const cell = payload?.[0]?.payload as DonutChartCellData | undefined

  if (!cell) return null

  return (
    <Box className={classes.tooltip}>
      <Flex align="center" gap={8}>
        <span
          className={classes.dot}
          style={{
            backgroundColor: cell.color,
          }}
        />

        <Text mb={0} variant="body_2_medium_black">
          {cell.label ?? cell.name}
        </Text>
      </Flex>

      {cell.description && (
        <Text mb={0} variant="body_4_gray">
          {cell.description}
        </Text>
      )}
    </Box>
  )
}
